import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Icon } from '@iconify/react';

const GalleryOverlay = ({ galleryOpen, closeGallery, currentImageIndex, images, navigateGallery }) => {
  if (!galleryOpen) return null;

  return (
    <AnimatePresence>
      <motion.div 
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="fixed inset-0 z-[100] bg-black/95 backdrop-blur-xl flex items-center justify-center p-4"
        onClick={closeGallery}
      >
        <button 
          onClick={closeGallery}
          className="absolute top-8 right-8 text-white/50 hover:text-white transition-colors p-2 hover:bg-white/10 rounded-full"
        >
          <Icon icon="mdi:close" className="text-4xl" />
        </button>

        <div className="relative w-full max-w-6xl aspect-video flex items-center justify-center" onClick={(e) => e.stopPropagation()}>
          <button 
            onClick={() => navigateGallery('prev')}
            className="absolute left-4 z-10 p-4 bg-blue-600/10 hover:bg-blue-600/20 text-blue-500 rounded-full transition-all hover:scale-110 border border-blue-500/20"
          >
            <Icon icon="mdi:chevron-left" className="text-4xl" />
          </button>

          <AnimatePresence mode="wait">
            <motion.img 
              key={currentImageIndex}
              src={images[currentImageIndex]} 
              initial={{ opacity: 0, x: 40 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -40 }}
              transition={{ duration: 0.4, ease: "easeOut" }}
              className="max-h-[85vh] max-w-full object-contain shadow-2xl rounded-lg"
            />
          </AnimatePresence>

          <button 
            onClick={() => navigateGallery('next')}
            className="absolute right-4 z-10 p-4 bg-blue-600/10 hover:bg-blue-600/20 text-blue-500 rounded-full transition-all hover:scale-110 border border-blue-500/20"
          >
            <Icon icon="mdi:chevron-right" className="text-4xl" />
          </button>

          <div className="absolute -bottom-12 left-1/2 -translate-x-1/2 flex gap-3">
            {images.map((_, i) => (
              <div 
                key={i}
                className={`w-2.5 h-2.5 rounded-full transition-all duration-300 ${i === currentImageIndex ? 'bg-blue-600 w-8' : 'bg-white/20'}`}
              />
            ))}
          </div>
        </div>
      </motion.div>
    </AnimatePresence>
  );
};

export default GalleryOverlay;
